import React, { useState } from 'react';
import { type ToggleButtonsProps } from './ToggleButtons.types';

const ToggleButtons: React.FC<ToggleButtonsProps> = ({ items, selected }) => {
  const [selectedOption, setSelectedOption] = useState(selected);

  const handleClick = (value: string) => {
    setSelectedOption(value);
  };

  return (
    <div className="toggle-buttons">
      {items &&
        items.map((item) => (
          <button
            className={`toggle-buttons__button ${selectedOption === item.title ? 'selected' : ''}`}
            key={item.id}
            onClick={() => handleClick(item.title)}
          >
            {item.title}
          </button>
        ))}
    </div>
  );
};

export default ToggleButtons;
